<template>
  <card-layout
    :span="6"
    :padding="24"
    invert
    :alert="alert"
  >
    <el-form
      el-loading-background="fixed-white"
      el-loading-opacity=".8"
      :model="loginForm"
      :rules="loginFormRules"
      ref="loginForm"
      @submit="submit">
      <el-row
        type="flex"
        justify="center"
        align="top"
        class="el-row--fullscreen"
      >
        <span
          :class="{
            'mx-8': true,
            'el-text': true,
            'el-text--display-regular': true,
            'el-text--ellipsis': true,
            'el-text--color-nav-primary': true,
          }"
        >
          Sign in
        </span>
      </el-row>
      <el-row
        type="flex"
        justify="center"
        align="top"
        class="el-row--fullscreen pt-8"
        style="height: 82px"
      >
        <el-col
          :span="24"
        >
          <el-form-item
            prop="username"
          >
            <el-input
              v-model="loginForm.login"
              label="Username"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        justify="center"
        align="top"
        class="el-row--fullscreen pt-8"
        style="height: 82px"
      >
        <el-col
          :span="24"
        >
          <el-form-item
            prop="password"
          >
            <el-input
              v-model="loginForm.password"
              label="Password"
              type="password"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-button
        class="mt-8"
        fluid
        :loading="loading"
        native-type="submit">
        Sign in
      </el-button>
    </el-form>
  </card-layout>
</template>

<script>
// import store from '@/store';
import CardLayout from '../../components/layout/Card';
import {mapActions} from 'vuex'

export default {
  name: 'LoginIndex',
  components: {
    CardLayout,
  },
  data() {
    return {
      loading: false,
      loginForm: {
        login: '',
        password: '',
      },
      loginFormRules: {
        login: [
          { required: true, message: 'test' },
        ],
        password: [
          { required: true, message: 'test' },
        ],
      },
      alert: {
        show: false,
        type: 'error',
        description: 'test',
        border: { top: true, bottom: true },
      },
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   store.dispatch('setBranding', { color_scheme: 'default' });
  //   next();
  // },
  methods: {
    ...mapActions({
      login: 'login'
    }),
    submit() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            this.login(this.loginForm)
          } catch (e) {
            // TODO
          } finally {
            // this.loginForm.password = '';
            // this.loading = false;
          }
        }
      });
    },
  },
};
</script>
